// extracted by mini-css-extract-plugin
export default {"button":"styles_button__1wPz5","animate":"styles_animate__8e2+0","buttonText":"styles_buttonText__jGHOc"};